module.exports = __webpack_public_path__ + "static/media/image-outros.8c88c810.svg";